/* ============================================================
   DORē PARIS — Theme JS
   ============================================================ */

(function() {
  'use strict';

  /* ── CUSTOM CURSOR ── */
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');

  if (cursor && ring) {
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top = mouseY + 'px';
    });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = ringX + 'px';
      ring.style.top = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    const hoverEls = 'a, button, .cat-card, .product-card, .strip-item, .service-item, select, input, [role="button"]';
    document.querySelectorAll(hoverEls).forEach(el => {
      el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
      el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
    });
  }

  /* ── NAVBAR SCROLL ── */
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── MOBILE NAV ── */
const hamburger = document.getElementById('navHamburger');
const mobileNav = document.getElementById('navMobile');
const mobileClose = document.getElementById('navMobileClose');

function closeMobileNav() {
  mobileNav.classList.remove('open');
  hamburger.setAttribute('aria-expanded', 'false');
  mobileNav.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

if (hamburger && mobileNav) {
  hamburger.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', open);
    mobileNav.setAttribute('aria-hidden', !open);
    document.body.style.overflow = open ? 'hidden' : '';
  });

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileNav);
    mobileClose.addEventListener('touchend', function(e) {
      e.preventDefault();
      closeMobileNav();
    });
  }

  mobileNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });
}

  /* ── SCROLL REVEAL ── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  /* ── ANNOUNCEMENT BAR CLOSE (optional) ── */
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const dismissed = sessionStorage.getItem('announcement-dismissed');
    if (dismissed) announcementBar.style.display = 'none';
  }

  /* ── CART DRAWER / MINI-CART (AJAX) ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badges = document.querySelectorAll('.cart-badge');
        badges.forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }

  /* ── WISHLIST (localStorage) ── */
function updateWishlistBadge() {
  const badge = document.getElementById('WishlistBadge');
  if (!badge) return;
  const wl = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');
  badge.textContent = wl.length;
  badge.style.display = wl.length ? 'flex' : 'none';
}

function initWishlist() {
  updateWishlistBadge();

  const wishlistBtns = document.querySelectorAll('.wishlist-btn');
  wishlistBtns.forEach(btn => {
    const productId     = btn.dataset.productId;
    const productHandle = btn.dataset.productHandle;
    const wishlist = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');

    if (productId && wishlist.find(item => item.id == productId)) {
      btn.textContent = '♥';
      btn.style.color = 'var(--or-rose)';
    }

    btn.addEventListener('click', function() {
      if (!productId) return;
      let wl  = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');
      const idx = wl.findIndex(item => item.id == productId);
      if (idx === -1) {
        wl.push({ id: productId, handle: productHandle });
        this.textContent = '♥';
        this.style.color = 'var(--or-rose)';
      } else {
        wl.splice(idx, 1);
        this.textContent = '♡';
        this.style.color = '';
      }
      localStorage.setItem('dore-wishlist', JSON.stringify(wl));
      updateWishlistBadge();
    });
  });
}
initWishlist();


  /* ── PRODUCT FORM — Add to cart feedback ── */
  const productForms = document.querySelectorAll('.product-form-submit');
  productForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = this.querySelector('[name="add"]');
      if (btn && !btn.disabled) {
        const orig = btn.textContent;
        btn.textContent = 'Ajout en cours...';
        setTimeout(() => {
          btn.textContent = orig;
          updateCartCount();
        }, 1500);
      }
    });
  });


  /* ── COLLECTION SORT ── */
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── NEWSLETTER FORM FEEDBACK ── */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function() {
      const btn = this.querySelector('.newsletter-btn');
      if (btn) {
        btn.textContent = '...';
        setTimeout(() => { btn.textContent = 'S\'inscrire'; }, 3000);
      }
    });
  }

  /* ── LAZY LOADING IMAGES POLYFILL ── */
  if ('loading' in HTMLImageElement.prototype === false) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          imageObserver.unobserve(img);
        }
      });
    });
    images.forEach(img => imageObserver.observe(img));
  }

  /* ── SMOOTH ANCHOR SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── CURSOR REFRESH ON DYNAMIC CONTENT ── */
  if (cursor && ring) {
    document.addEventListener('shopify:section:load', () => {
      const hoverEls = 'a, button, .cat-card, .product-card, .strip-item, .service-item';
      document.querySelectorAll(hoverEls).forEach(el => {
        el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
        el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
      });
    });
  }

})();

/* ── SEARCH OVERLAY ── */
(function() {
  const overlay   = document.getElementById('SearchOverlay');
  const toggleBtn = document.getElementById('SearchToggle');
  const closeBtn  = document.getElementById('SearchClose');
  const backdrop  = document.getElementById('SearchBackdrop');
  const input     = document.getElementById('SearchInput');
  const results   = document.getElementById('SearchResults');
  if (!overlay || !toggleBtn) return;

  let debounceTimer;

  function openSearch() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input && input.focus(), 300);
  }

  function closeSearch() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (results) results.innerHTML = '';
    if (input) input.value = '';
  }

  toggleBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
    if ((e.key === 'k' && (e.metaKey || e.ctrlKey))) { e.preventDefault(); openSearch(); }
  });

  /* Live search via Shopify Predictive Search API */
  if (input && results) {
    input.addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(debounceTimer);

      if (q.length < 2) { results.innerHTML = ''; return; }

      results.innerHTML = '<div class="search-loading"><div class="search-loading__dots"><span></span><span></span><span></span></div></div>';

      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title`)
          .then(r => r.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length === 0) {
              results.innerHTML = '<p class="search-no-result">Aucun résultat pour "' + q + '"</p>';
              return;
            }
            const grid = document.createElement('div');
            grid.className = 'search-results-grid';
            products.forEach(p => {
              const item = document.createElement('a');
              item.className = 'search-result-item';
              item.href = p.url;
              const img = p.featured_image?.url
                ? `<img src="${p.featured_image.url}&width=300" alt="${p.title}" loading="lazy">`
                : `<div style="aspect-ratio:1;background:#111;display:flex;align-items:center;justify-content:center;font-size:2rem;opacity:0.1;">✦</div>`;
              const price = p.price ? (parseInt(p.price)).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) : '';
              item.innerHTML = `${img}<div class="search-result-item__info"><p class="search-result-item__name">${p.title}</p><p class="search-result-item__price">${price}</p></div>`;
              grid.appendChild(item);
            });
            results.innerHTML = '';
            results.appendChild(grid);
          })
          .catch(() => { results.innerHTML = ''; });
      }, 300);
    });
  }
})();
/* ── CART QUANTITY BUTTONS ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;

  const line = btn.dataset.line;
  const input = btn.closest('.quantity-selector')?.querySelector('input');
  if (!input || !line) return;

  let qty = parseInt(input.value) || 1;
  if (btn.classList.contains('qty-btn--plus')) qty++;
  if (btn.classList.contains('qty-btn--minus')) qty = Math.max(0, qty - 1);

  input.value = qty;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line), quantity: qty })
  })
  .then(r => r.json())
  .then(() => location.reload())
  .catch(e => console.error(e));
});